/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_CommunityInputs */

const en_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const de_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const fr_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté`)
};

const es_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const it_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunità`)
};

const nl_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const pl_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Społeczność`)
};

const fi_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisö`)
};

const da_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskab`)
};

const sv_pricing_compare_community = /** @type {(inputs: Pricing_Compare_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

/**
* | output |
* | --- |
* | "Community" |
*
* @param {Pricing_Compare_CommunityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_community = /** @type {((inputs?: Pricing_Compare_CommunityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_CommunityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_community(inputs)
	if (locale === "fr") return fr_pricing_compare_community(inputs)
	if (locale === "es") return es_pricing_compare_community(inputs)
	if (locale === "it") return it_pricing_compare_community(inputs)
	if (locale === "nl") return nl_pricing_compare_community(inputs)
	if (locale === "pl") return pl_pricing_compare_community(inputs)
	if (locale === "fi") return fi_pricing_compare_community(inputs)
	if (locale === "da") return da_pricing_compare_community(inputs)
	if (locale === "sv") return sv_pricing_compare_community(inputs)
	return en_pricing_compare_community(inputs)
});